import { AstroCareersViewTransitions } from "@components/AstroViewTransitions"
import CareersCard from "@components/Careers/CareersCard"
import { BackButton } from "@components/SiteShell"
import { sanitizeRichHtml } from "@lib/sanitizeHtml"
import * as m from "@paraglide/messages"
import type { CareerItem, SupportedLocale as Lang } from "@site-types/site"

export function CareerDetailPage({ locale, position }: { locale: Lang; position: CareerItem }) {
  return (
    <>
      <AstroCareersViewTransitions careers={[position]} />
      <div className="back-button">
        <BackButton
          locale={locale}
          page="careers"
        />
      </div>
      <div className="career-detail-container">
        <div className="sidebar">
          <CareersCard
            locale={locale}
            position={position}
          />
        </div>
        <div className="intro">
          <h1 className="title">{position.title}</h1>
          <p className="blurb cut-corners">{position.newsBlurb}</p>
        </div>
        <article className="post">
          <div dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(position.description) }} />
          <a
            className="apply-link"
            href={`/${locale}/contact/${position.slug?.current}`}
          >
            <div className="apply">
              <div className="cut-corners">
                <h3>{m.careers_post_apply({}, { locale: locale }).toUpperCase()}</h3>
                <p>{m.careers_post_apply_description({}, { locale: locale })}</p>
              </div>
            </div>
          </a>
        </article>
      </div>
    </>
  )
}
